import { ErrorMessage } from 'formik';
import { ErrorLabel as Error } from './styles';

const ErrorLabel = (props: any) => {
  if (!props.name) return null;
  return (
    <Error>
      <ErrorMessage name={props.name} />
    </Error>
  );
};

export default ErrorLabel;
